const zeroPad = (value, length) => `${value}`.padStart(length, "0");

export const format = (date) => {
  const d = new Date(date);
  const day = zeroPad(d.getDate(), 2);
  const month = zeroPad(d.getMonth() + 1, 2);
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
};
